// Module
var code = "<div ng-repeat=\"wf in $ctrl.wfs\"> <svg style=\"color:{};\" width=\"16\" height=\"16\" ng-attr-view_box=\"{{ $ctrl.viewBox }}\"> <use href=\"#wf-icon_single\"/> </svg> {{ wf.title }} </div> ";
// Exports
export default code;